'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { AssetField } from '@/lib/asset'
import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxCTAblock } from './CTAblock'
import { CTAblockProps } from './CTAblock'

interface CtablockBlokProps {
  blok: {
    title: CTAblockProps['title']
    description?: CTAblockProps['description']
    content?: SbBlokData[]
    button?: SbBlokData[]
    asset?: AssetField
    layout: CTAblockProps['layout']
    padding?: SbBlokData[]
    background?: SbBlokData[]
    color?: any
    border?: boolean
    halfHalf?: boolean
    topHalfBackground?: any
    bottomHalfBackground?: any
    buttonBelow?: boolean
  } & SbBlokData
}

const CTABlock: FC<CtablockBlokProps> = ({ blok }) => {
  let stylePanel = stylePanelSBData(blok.colour, blok.background, undefined, blok.padding)

  const textColor = blok.color ? blok.color[0]?.colour : stylePanel.textColor

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxCTAblock
        title={blok.title}
        description={blok.description}
        layout={blok.layout}
        content={
          blok.content &&
          blok.content.map((content: any) => (
            <StoryblokServerComponent key={content._uid} blok={content} />
          ))
        }
        asset={
          blok.asset && { src: blok.asset.filename, alt: blok.asset.alt, focus: blok.asset.focus }
        }
        button={
          blok.button &&
          blok.button.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        backgroundColor={stylePanel.backgroundColor}
        textColor={textColor}
        padding={stylePanel.padding}
        border={blok.border ? blok.border : false}
        halfHalf={blok.halfHalf ? blok.halfHalf : false}
        topHalfBackground={blok?.topHalfBackground ? blok?.topHalfBackground[0]?.colour : null}
        bottomHalfBackground={
          blok?.bottomHalfBackground ? blok?.bottomHalfBackground[0]?.colour : null
        }
        buttonBelow={blok.buttonBelow}
      />
    </div>
  )
}

export default CTABlock
